import { useCallback } from 'react'
import { useQuery } from '@tanstack/react-query'

import { SellTreezService } from '@/services/sell-treez'
import { SellTreez } from '@/models/sellTreez'

export const useSellTreez = (sellTreezId?: string) => {
  const queryKey = ['sell-treez', sellTreezId]

  const getSellTreez = useCallback(async () => {
    const response = await SellTreezService.getSellTreezDetail(sellTreezId as string)
    return response.data as SellTreez
  }, [sellTreezId])

  const { data, isLoading, refetch } = useQuery({
    queryKey,
    queryFn: getSellTreez,
    enabled: !!sellTreezId?.length,
    refetchInterval: 5000,
  })

  return { sellTreez: data, isLoading, refetch }
}
